import { connect } from 'react-redux';
import { createTranscript, setField } from '@actions/transcript';
import TranscriptCreationPage from './TranscriptCreationPage';

const mapStateToProps = (state) => ({
  isSubmitting: state.transcript.isSubmitting,
  isAITranscriptNeeded: state.transcript.isAITranscriptNeeded,
  isTranscriptNeeded: state.transcript.isTranscriptNeeded,
});

const mapDispatchToProps = {
  createTranscript,
  setField,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(TranscriptCreationPage);



// WEBPACK FOOTER //
// ./components/pages/TranscriptCreationPage/index.js